import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Mobile, Landscape } from "../Response";
const About = () => {
  const back = useSelector((state) => state.switch.back);
  return (
    <Container>
      <Wrap>
        <TextDESC back={back}>More About Me</TextDESC>
        <TextDESC type="thin" back={back}>
          {/* I am a Full Stack Web Application Developer  */}
          <Doc back={back}>
            “I’m a<span> MERN STACK WEB DEVELOPER ,</span>
          </Doc>
          I have very well experience for about (2 years) With Web Technology
          I'm willing to develop a scalable Web Application for you and your
          business by using Express JS, Node JS, React JS, & MongoDB, Firebase.
          I will build looking unique, fast,easy to use, and user-friendly web
          application for you.
          <br /> You will definitely be 100% satisfied by the outcome,And also I
          can design UI(user-interface) from your products on (Web &
          Mobile)Applications,
          <br /> if you have and idea or a bussiness – I can help!
        </TextDESC>
      </Wrap>
    </Container>
  );
};
export default About;
const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 60vh;
  margin: 100px 0px;
  display: flex;

  justify-content: center;
  align-items: center;
  ${Mobile({ height: "65vh", margin: "50px 0px 0px 0px" })}
  ${Landscape({ width: "100%", height: " 60vh" })}
`;
const Wrap = styled.div`
  overflow: hidden;

  width: 56%;
  height: 80%;
  ${Mobile({ width: "97%", height: "95%" })}
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-right: 2px solid #45e00e;
  ${Mobile({ border: "none" })}
  ${Landscape({ width: "80%", height: " 95%" })}
`;
const TextDESC = styled.h6`
  line-height: 1.7;

  color: ${(props) =>
    props.back === "sun" ? "#929292" : " rgba(228, 236, 240, 0.7)"};

  font-size: ${(props) => (props.type == "thin" ? 23 : 25)}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // gap: 20px;
  align-items: center;
  font-weight: ${(props) => (props.type ? 400 : 600)};
  text-align: ${(props) => props.type && "start"};
  margin: ${(props) => (props.type ? 20 : 0)}px;
  ${(props) =>
    props.type
      ? Mobile({ fontSize: 14, fontWeight: 400 })
      : Mobile({ fontSize: 18, fontWeight: 600 })};
  ${(props) =>
    props.type
      ? Landscape({ fontSize: 14, fontWeight: 400 })
      : Landscape({ fontSize: 16, fontWeight: 600 })};
`;
const Doc = styled.h5`
  align-self: flex-start;
  margin-bottom: 6px;
  font-size: 22px;
  span {
    color: ${(props) =>
      props.back === "sun" ? "#747474" : "rgba(228, 236, 240, 0.9)"};
  }
  ${Mobile({ fontSize: 14 })}
  ${Landscape({ fontSize: 14, margin: 1 })}
`;
